"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastManager = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ToastManager = {
  toasts: new Map(),
  listeners: new Map(),
  addToast: function addToast(toast) {
    var id = Date.now();
    this.toasts.set(id, _objectSpread({
      id: id
    }, toast));
    this.onChange();
    return id;
  },
  clearAllToast: function clearAllToast() {
    this.toasts.clear();
    this.onChange();
  },
  removeToast: function removeToast(id) {
    this.toasts["delete"](id);
    this.onChange();
  },
  replaceToast: function replaceToast(id, toast) {
    if (this.isActive(id)) {
      this.toasts.set(id, _objectSpread(_objectSpread({}, this.toasts.get(id)), toast));
      this.onChange();
      return id;
    } else {
      return this.addToast(toast);
    }
  },
  addListener: function addListener(cb) {
    this.listeners.set(cb, cb);
  },
  removeListener: function removeListener(cb) {
    this.listeners["delete"](cb);
  },
  isActive: function isActive(id) {
    return this.toasts.has(id);
  },
  onChange: function onChange() {
    var toasts = Array.from(this.toasts.values());
    this.listeners.forEach(function (listener) {
      return listener(toasts);
    });
  }
};
exports.ToastManager = ToastManager;